import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const GlowButton = ({ children, variant = 'contained', href, to, onClick, ...props }) => {
  const MotionButton = motion(Button);

  const component = to ? Link : href ? 'a' : 'button';
  const linkProps = to ? { to } : href ? { href } : {};

  return (
    <MotionButton
      component={component}
      {...linkProps}
      onClick={onClick}
      variant={variant}
      {...props}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      sx={{
        background:
          variant === 'contained'
            ? 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)'
            : 'transparent',
        color: variant === 'contained' ? 'white' : '#a855f7',
        border: variant === 'outlined' ? '2px solid #a855f7' : 'none',
        borderRadius: '12px',
        padding: '12px 32px',
        fontWeight: 600,
        fontSize: '1rem',
        boxShadow: variant === 'contained' ? '0 0 20px rgba(168, 85, 247, 0.5)' : 'none',
        '&:hover': {
          boxShadow: variant === 'contained' ? '0 0 30px rgba(168, 85, 247, 0.8)' : 'none',
          background:
            variant === 'contained'
              ? 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)'
              : 'rgba(168, 85, 247, 0.1)',
        },
        ...props.sx,
      }}
    >
      {children}
    </MotionButton>
  );
};

export default GlowButton;

